import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, FormBuilder, Validators, ReactiveFormsModule, FormGroupDirective } from '@angular/forms';
import { ViewEncapsulation, NgModule, ChangeDetectorRef } from '@angular/core';
import { SetpasswordService } from './setpassword.service';
import { Router, ActivatedRoute } from '@angular/router';
declare var jQuery;
import { TranslateService } from '@ngx-translate/core';
import * as languageConfig from '../../assets/i18n/configuration/configuration.json';

@Component({
  selector: 'app-resetpassword',
  templateUrl: './setpassword.component.html',
  styleUrls: ['./setpassword.component.css'],
  providers: [SetpasswordService]
})
export class SetpasswordComponent implements OnInit {
  alertMessage: string;
  responseMessage: string;
  passSymbol: boolean;
  passwordAlert: string;
  passwordErrMessage: string;
  passLength: boolean;
  passNumber: any;
  sub: any;
  id: any;
  titleMessage = '';
  detailMessage = '';
  subTitleMessage = '';
  passwordResetToken = '';
  passValidated = false;

  resetPassForm = new FormGroup({
    password: new FormControl('', [Validators.required]),
    password1: new FormControl('', [Validators.required])
  });
  passwordChangeForm = new FormGroup({
    password: new FormControl('', [Validators.required]),
    password1: new FormControl('', [Validators.required])
  });
  languageConfiguration: any;
  constructor(
    public translate: TranslateService,
    private route: ActivatedRoute, 
    private _resetpasswordService: SetpasswordService, 
    private _router: Router) { 
      this.languageConfiguration = (languageConfig as any).default;
      translate.addLangs([this.languageConfiguration.languages]);
      translate.setDefaultLang(this.languageConfiguration.defaultLang);
      let selectedLang = sessionStorage.getItem('selectedLang');
      let langRegExp = new RegExp(this.languageConfiguration.languageRegexp);
      if(selectedLang){
        translate.use(selectedLang.match(langRegExp) ? selectedLang : this.languageConfiguration.defaultLang);  
      } else {
        const browserLang = translate.getBrowserLang();                  
        translate.use(browserLang.match(langRegExp) ? browserLang : this.languageConfiguration.defaultLang);  
      }     
    }
  data = { domain: '', userName: '', password: '', confirmPassword: '' };
  ngOnInit() {
    const body = document.getElementsByTagName('body')[0];
    body.classList.add('bgImg');
    // window.localStorage.removeItem('loginInfoObj');
    // window.localStorage.removeItem('token');
    this.passwordErrMessage = '';
    this.sub = this.route.params.subscribe(params => {
      if (params['token'] !== undefined)      {
        this.resetPasswordValidation(params['token']);
      }
    });

  }

  ngOnDestroy() {
    const body = document.getElementsByTagName('body')[0];
    body.classList.remove('bgImg');
  }

  hideRPWDWindow() {}
  validatePassword(val) {
    this.passwordAlert = '';
    this.passLength = false;
    this.passNumber = this.hasNumber(val);
    this.passSymbol = this.hasSymbol(val);
    if (val.length >= 6){
     this.passLength = true;
    }
    if (this.passSymbol && this.passLength && this.passNumber){
      this.passValidated = true;
    }else{
      this.passValidated = false;
    }
  }

   hasNumber(myString) {
    return /\d/.test(myString);
  }
  hasSymbol(myString) {
    const regexp = /[!@#$%^&*()]/;
    return regexp.test(myString);
  }

  resetPasswordValidation(data)
  {
    this.passwordResetToken = data;
    this._resetpasswordService.validateToken(data).subscribe(
      (response) => {
        if (JSON.stringify(response.message).indexOf('Valid Token') > 0)
        {
          if (response.domain && response.username)
          {
            this.data.domain =  response.domain;
            this.data.userName =  response.username;
          }else {
            this.data.domain =  'domain';
            this.data.userName =  'username';
          }
        }
      },
      (err) => {
        this.passwordResetToken = '';
        this.titleMessage =  'Invalid Form URL';
        this.detailMessage = 'This url is no more available.';
        /* jQuery('#errorModal').modal('show'); */
      },
      () => {
        console.log('COMPLETED');
      }
    );
  }
  redirect(){
    //Jquery('#errorModal').modal('hide');
    this._router.navigate(['/login']);
  }
  onresetPassFormSubmit()
  {
    this.alertMessage = '';
    const password = this.resetPassForm.value.password;
    const password1 = this.resetPassForm.value.password1;
    if (password === password1 && password !== '')
    {
      this.alertMessage = 'Processing...';
      this._resetpasswordService.changePassword(this.passwordResetToken, password).subscribe(
        (response) => {
          this.alertMessage = '';
          this.confirmResetPass();
          this._router.navigate(['/login']);
          return true;
         },
        (err) => {
          this.alertMessage = 'Error';
        },
        () => {
          console.log('COMPLETED');
          this.alertMessage = '';
        }
      );
    }else{
      this.alertMessage = 'Password empty or Does not match!';
      this.passwordAlert = 'Re-enter does not match. Please re-enter a matching password.';
      this.passwordErrMessage = 'Please re-enter a matching password.'
      this.passwordChangeForm.reset();
    }
  }
  confirmResetPass(){

      this.titleMessage = 'Reset Password';
      this.detailMessage = 'Password updated successfully!';
      this.subTitleMessage = '';
      window.localStorage.removeItem('admin_name');
      window.localStorage.setItem('resetpass', 'You’ve set your password')
  }
}
